import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthGuard } from './_helpers/auth.guard';
import { NoAuthGuard } from './_helpers/no-auth.guard';

const routes: Routes = [

  { path: '', component: LoginComponent, canActivate: [NoAuthGuard] },

  { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },

  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoAuthGuard] },

  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [NoAuthGuard] },

  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },

  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },

  { path: 'bookings', loadChildren: () => import('./booking/booking.module').then(m => m.BookingModule), canActivate: [AuthGuard] },

  { path: 'manage', loadChildren: () => import('./management/management.module').then(m => m.ManagementModule), canActivate: [AuthGuard] },

  { path: 'manage-customers', loadChildren: () => import('./manage-customers/manage-customers.module').then(m => m.ManageCustomersModule), canActivate: [AuthGuard] },

  { path: 'refund-management', loadChildren: () => import('./refund-management/refund-management.module').then(m => m.RefundManagementModule), canActivate: [AuthGuard] },

  { path: 'combo-booking', loadChildren: () => import('./combo-booking/combo-booking.module').then(m => m.ComboBookingModule), canActivate: [AuthGuard] },

  { path: 'reporting', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule), canActivate: [AuthGuard] },

  { path: 'complaints', loadChildren: () => import('./complaints/complaints.module').then(m => m.ComplaintsModule), canActivate: [AuthGuard] },

  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule), canActivate: [AuthGuard] },

  { path: 'manage/locations', loadChildren: () => import('./location/location.module').then(m => m.LocationModule), canActivate: [AuthGuard] },

  { path: 'chat', loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule), canActivate: [AuthGuard] },

  { path: '**', redirectTo: '/login' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
